import React, { useState, useContext } from "react";
import { UserContext } from "../context/UserContext"; // Import UserContext
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios
import {
  Container,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Box,
  IconButton,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import EmailIcon from "@mui/icons-material/Email";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import API_BASE_URL from "../config";

const Login = () => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState(""); // Changed from email to identifier
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        // You can switch back to `API_BASE_URL` if needed
        `${API_BASE_URL}/users/login`,
        {
          identifier, // Send identifier instead of email
          password,
        }
      );

      if (response.data.user) {
        setUser(response.data.user);
        console.log("User ID:", response.data.user.id);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("email", response.data.user.email);
        navigate("/");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.error);
      } else {
        setError("An error occurred while logging in.");
      }
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5, mb: 4 }}>
      <Card sx={{ p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography
            variant="h4"
            color="#42326e"
            fontWeight="bold"
            textAlign="center"
          >
            Login to CityZoom
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleLogin}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 3 }}>
              <EmailIcon color="action" />
              <TextField
                fullWidth
                label="Email or User ID"
                variant="outlined"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
              />
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
              <LockIcon color="action" />
              <TextField
                fullWidth
                label="Password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={togglePasswordVisibility} edge="end">
                      {showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 3,
                backgroundColor: "#42326e",
                color: "white",
                "&:hover": {
                  backgroundColor: "black",
                  color: "white",
                },
              }}
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Login"
              )}
            </Button>
          </form>

          <Typography textAlign="center" sx={{ mt: 3 }}>
            Not registered yet?{" "}
            <Button
              onClick={() => navigate("/signup")}
              sx={{ color: "#42326e" }}
            >
              Sign Up Now
            </Button>
          </Typography>

          <Typography textAlign="right" sx={{ mt: 3 }}>
            <Button
              sx={{
                backgroundColor: "#42326e",
                color: "white",
                "&:hover": {
                  backgroundColor: "black",
                  color: "white",
                },
              }}
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </Button>
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Login;
